// extracted by mini-css-extract-plugin
module.exports = {"noDataWrapper":"emptyContent__noDataWrapper__dsG","bounceIn":"emptyContent__bounceIn__PPy","highlightWallMessage":"emptyContent__highlightWallMessage__3zE"};